module.exports = __webpack_public_path__ + "static/media/vacasa_identity_lockup_horizontal_blue.1b2a9262.svg";